import { createContext } from "react";

interface IEnrichmentsContext {
  Enrichments_refetchEnrichmentFlows: () => Promise<any>;
}

const EnrichmentsContext = createContext<IEnrichmentsContext>({
  Enrichments_refetchEnrichmentFlows: () => Promise.resolve(),
});

export default EnrichmentsContext;
